import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQueryClient } from "react-query";
import FormWrapper from "src/components/FormWrapper";
import { FormProvider, RHFTextField } from "src/components/hook-form";
import { saveChecklistCategory } from "src/pages/api";
import * as Yup from "yup";

const defaultValues = {
  name: "",
};

const schema = Yup.object().shape({
  name: Yup.string().trim().required("Category name is required"),
});

export default function AddCategory({ onClose, row, isEditMode }) {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  const { handleSubmit, reset, setValue } = methods;

  useEffect(() => {
    if (isEditMode && row) {
      setValue("name", row.name || "");
    }
  }, [isEditMode, row, setValue]);

  const mutation = useMutation(
    (formData) =>
      saveChecklistCategory({ id: isEditMode ? row.id : undefined, req: formData }),
    {
      onSuccess: () => {
        enqueueSnackbar(
          isEditMode ? "Category updated successfully" : "Category created successfully",
          { variant: "success" }
        );
        queryClient.invalidateQueries(["checklist-categories"]);
        onClose();
      },
      onError: (error) => {
        const apiMessage =
          error?.response?.data?.details ||
          error?.response?.data?.error ||
          error?.response?.data?.message;
        enqueueSnackbar(apiMessage || error?.message || "Failed to save category", {
          variant: "error",
        });
      },
    }
  );

  const onSubmit = (data) => {
    mutation.mutate({ name: data.name, isActive: true });
  };

  return (
    <FormWrapper
      title={isEditMode ? "Edit Checklist Category" : "Add Checklist Category"}
      onClose={onClose}
      onSubmit={handleSubmit(onSubmit)}
      onReset={() => reset(defaultValues)}
      loading={mutation.isLoading}
      isEditMode={isEditMode}
    >
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}>
            <RHFTextField name="name" label="Category Name" autoFocus />
          </Grid>
        </Grid>
      </FormProvider>
    </FormWrapper>
  );
}
